import Text, { TextTag, TEXT_VARIANT } from '@pixum/text';
import type { VoucherUnionNode } from 'data-layer/src/lib/transformers/types';
import { VOUCHER_VARIANTS, type VoucherVariant } from 'utils';
import { getVoucherDescription } from '../utils';

type CampaignHeaderProps = {
  voucher: VoucherUnionNode;
  variant: VoucherVariant;
  openInDialog?: boolean;
  constants: Record<string, string>;
};

/**
 * Campaign header displaying voucher headline and description.
 * Handles both VoucherNode and VoucherNewNode types.
 * Used in the content column of the 2-column layout.
 *
 * Text behavior:
 * - Dialog: Shows "thank you" headline confirming download (generic for all variants)
 *          Description uses variant-specific text only for "others" variant
 * - Page: Shows voucher-specific headline and description from CMS
 *
 * Rationale: Dialog focuses on download confirmation, page module shows detailed voucher info
 */
export function CampaignHeader({ voucher, variant, openInDialog, constants }: CampaignHeaderProps) {
  // Dialog-specific description only applies to "others" variant
  const showDialogSpecificText = openInDialog && variant === VOUCHER_VARIANTS.OTHERS;

  const headline = openInDialog ? constants.dialogHeadlineVoucherOthersVariant : voucher.headline;

  const description = showDialogSpecificText
    ? constants.dialogDescriptionVoucherOthersVariant
    : getVoucherDescription(voucher);

  return (
    <>
      <Text tag={TextTag.H2} variant={TEXT_VARIANT.TITLE_2}>
        <span dangerouslySetInnerHTML={{ __html: headline }}></span>
      </Text>
      <Text variant={TEXT_VARIANT.BODY}>
        <span dangerouslySetInnerHTML={{ __html: description }}></span>
      </Text>
    </>
  );
}
